module.exports = __webpack_public_path__ + "static/media/doc08.12f97143.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc08.png
// module id = 60
// module chunks = 0